module.exports = __webpack_public_path__ + "img/custom5.153e197e.png";